// @mui
import { Container, Typography } from '@mui/material';
import { m } from 'framer-motion';
// assets
import { ForbiddenIllustration } from '../assets/illustrations';
// components
import { MotionContainer, varBounce } from '../components/animate';
import { IPermission, IRole, hasPermission } from '../utils/permissions';
//
import { useAuthContext } from './useAuthContext';

// ----------------------------------------------------------------------

type RoleBasedGuardProp = {
  hasContent?: boolean;
  permission?: IPermission | IRole;
  children: React.ReactNode;
};

export default function PermissionBasedGuard({
  hasContent,
  permission,
  children,
}: RoleBasedGuardProp) {
  // Logic here to get current user role
  const { user } = useAuthContext();

  if (typeof permission !== 'undefined' && !hasPermission(user, permission)) {
    return hasContent ? (
      <Container component={MotionContainer} sx={{ textAlign: 'center' }}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            Permission Denied
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            You do not have permission to access this page
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
        </m.div>
      </Container>
    ) : null;
  }

  return <> {children} </>;
}
